export default class Location {
  constructor ({ lat, lng, updated_at: updatedAt }) {
    this.lat = lat
    this.lng = lng
    this.updated_at = updatedAt
  }
}
